import { useI18n } from '../../utils/i18n'
import { IconButton } from './IconButton'
import { Languages } from 'lucide-react'

export function LanguageToggle({ className = '' }) {
  const { lang, setLang, t } = useI18n()

  return (
    <IconButton
      onClick={() => setLang(lang === 'zh' ? 'en' : 'zh')}
      className={className}
      title={lang === 'zh' ? t('switchToEnglish') : t('switchToChinese')}
      aria-label="toggle-language"
    >
      <Languages className="w-5 h-5" />
    </IconButton>
  )
}
